import React, { useCallback } from 'react';

import VoiceTransferirRamalSettings from './VoiceTransferirRamalSettings';
import VoiceTTSAudioSettings from './VoiceTTSAudioSettings';
import VoiceConfirmarVendaSettings from './VoiceConfirmarVendaSettings';
import VoiceTTSAudioASRSettings from './VoiceTTSAudioASRSettings';
import VoiceFinalizarAtendimentoSettings from './VoiceFinalizarAtendimentoSettings';
import VoiceTransferirVendedorSettings from './VoiceTransferirVendedorSettings';
import VoiceAgendarMailingSettings from './VoiceAgendarMailingSettings';
import VoiceDTFMSettings from './VoiceDTFMSettings';
import VoiceSMSSettings from './VoiceSMSSettings';
import VoiceWebApiListSettings from './VoiceWebApiListSettings';

export default ({ item, ...props }) => {
  const getVoiceItemSettingsComponent = useCallback((type) => {
    const voiceItemTypes = {
      VoiceTransferirRamalInternoExterno: VoiceTransferirRamalSettings,
      VoiceTTSAudio: VoiceTTSAudioSettings,
      VoiceConfirmarVenda: VoiceConfirmarVendaSettings,
      VoiceTTSAudioASR: VoiceTTSAudioASRSettings,
      VoiceFinalizarAtendimento: VoiceFinalizarAtendimentoSettings,
      VoiceTransferirRamalLocalizadorVendedor: VoiceTransferirVendedorSettings,
      VoiceAgendarMailing: VoiceAgendarMailingSettings,
      VoiceTTSAudioDTMF: VoiceDTFMSettings,
      VoiceSMS: VoiceSMSSettings,
      VoiceWebApiList: VoiceWebApiListSettings,
    };

    return voiceItemTypes[type];
  }, []);

  const VoiceItemSettingsComponent = getVoiceItemSettingsComponent(item?.type);

  return <VoiceItemSettingsComponent item={item} {...props} />;
};
